module.exports = __webpack_public_path__ + "static/media/video-active.59756862.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/video-active.svg
// module id = 283
// module chunks = 0